import { memo, useEffect, useReducer, useCallback } from 'react';
import { Modal, Text, useTheme } from 'hoi-poi-ui';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';
import AutomationsLog from '../../AutomationsLog';

import './styles.scss';

const initialState = {
    id: null,
    data: null,
    open: false,
};

function reducer(state, action) {
    switch (action.type) {
        case 'init':
            return {
                ...state,
                open: true,
                data: action.data,
                id: action.id,
            };
        case 'load':
            return {
                ...state,
                canRender: true,
            };
        case 'close':
            return {
                ...state,
                open: false,
            };
        default:
            throw new Error('No action provided');
    }
}

const LogsModal = memo(({ onRef }) => {
    const theme = useTheme();
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        onRef &&
            onRef({
                open(automation) {
                    dispatch({
                        type: 'init',
                        data: automation,
                        id: automation.id,
                    });
                },
            });
    }, [onRef]);

    const onRequestClose = useCallback(() => {
        dispatch({ type: 'close' });
    }, []);

    if (!state.open) return null;

    return (
        <Modal
            className="fm-automation__logs-modal"
            overlayClassName="fm-automation__logs-modal__overlay"
            title={getLiteralWithParameters('label_automation_history_one_title', [
                state.data?.name,
            ])}
            preComponent={
                <Text color={theme.colors.textLight.secondary}>
                    {getLiteral('label_automation_history_desc')}
                </Text>
            }
            size="huge"
            useContentStaticHeight
            onRequestClose={onRequestClose}
            onConfirm={onRequestClose}
            confirmText={getLiteral('action_done')}
            isOpen={state.open}
        >
            <div className="fm-automation__logs-modal__content">
                <AutomationsLog
                    logId={state.id}
                    showAutomationName={false}
                    showFiltersSidebar={false}
                    canCreate={false}
                />
            </div>
        </Modal>
    );
});

export default LogsModal;
